import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getBusinessLines} from 'src/openapi/admin/apis/GetBusinessLinesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectBusinessLines} from './services/dictionary-slice';

export const useBusinessLines = () => {
    const apiDispatch = useAppDispatch();
    const businessLines = useSelector(selectBusinessLines);

    const loadBusinessLines = useCallback(() => {
        if (!businessLines.length) {
            apiDispatch(getBusinessLines());
        }
    }, [businessLines.length, apiDispatch]);

    return {businessLines, loadBusinessLines};
};
